import { useCallback, useContext, useEffect, useState } from 'react'

// import { FirebaseApp } from '@firebase/app-types'
import { MessagingCompat } from '@firebase/messaging-compat/dist/src/messaging-compat'
import { isProduction } from '@hhgtech/hhg-components/constants'
import { PATHS } from 'api/paths'
import {
  callApi,
  callApiWithAuth,
  getSSOPath,
  getSubotCookieId,
  getWindowId,
} from 'api/utils'
import { GA_TOKEN_COOKIE } from 'interfaces/constants'
import Cookies from 'js-cookie'
import { AppContext } from 'state/appContext'

const firebaseProdConfig = {
  apiKey: 'AIzaSyC9O6DE5wAOF6DMSzmIEzSVmXCoaHsHmc4',
  authDomain: 'hello-bacsi-vn-ga4.firebaseapp.com',
  projectId: 'hello-bacsi-vn-ga4',
  storageBucket: 'hello-bacsi-vn-ga4.appspot.com',
  messagingSenderId: '26303719081',
  appId: '1:26303719081:web:aaea66a4d22a6af295ebb8',
  measurementId: 'G-39XDWGS67Q',
}
const firebaseStagingConfig = {
  apiKey: 'AIzaSyDn4X1AgwtNimq1WAvGoIBqBSEUaG-un60',
  authDomain: 'hhg-mobile-app.firebaseapp.com',
  databaseURL:
    'https://hhg-mobile-app-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'hhg-mobile-app',
  storageBucket: 'hhg-mobile-app.appspot.com',
  messagingSenderId: '260545139180',
  appId: '1:260545139180:web:5f801637ae6ee1294df0c9',
}
const firebaseConfig = isProduction ? firebaseProdConfig : firebaseStagingConfig
const vapidKey = isProduction
  ? 'BFzHChPKyLbu-ix2QyY4oUDDBePZvGeOxWHoNmMegPuT7JTmvjyOb8IWRnxmZpldx-iZE1IUmhaHre19VoQLoXk'
  : 'BOfPnteGbmk4i2LCqoSj5Pu0j-dobbBGmpc0zr2Gwzz6eLXddwio2jJz-yl_Ziwo33Q3QvX53GXISwe60uqCTRA'

const TIMEOUT_TO_LOAD = 5000

// let app: FirebaseApp
let messaging: MessagingCompat | null = null

type Props = { isLogin: boolean }

const FCM_TOKEN_KEY = 'fcm_token'

const Log = (...args: any) => {
  if (location.href.includes('debug')) {
    if (location.href.includes('alert')) {
      setTimeout(() => {
        alert(args.join('|'))
      }, 0)
    }

    console.log(...args)
  }
}

const waitForUntilFinished = (params: {
  condition: () => boolean
  finished: () => void
  timeout?: number
}) => {
  const condition = params.condition
  const finished = params.finished
  const timeout = params.timeout || 10000

  const startTime = new Date().getTime()
  const intervalId = setInterval(() => {
    if (condition && condition()) {
      clearInterval(intervalId)
      finished && finished()
    }
    const endTime = new Date().getTime()

    if (endTime - startTime > timeout) {
      clearInterval(intervalId)
    }
  }, 300)
}

export const FirebaseWebPush = ({ isLogin }: Props) => {
  const [isFirebaseReady, setIsFirebaseReady] = useState(false)
  const [isFirebaseMsgReady, setIsFirebaseMsgReady] = useState(false)
  const [isLoadScript, setIsLoadScript] = useState(false)
  const { pushNotifications } = useContext(AppContext)

  const requestClientIp = useCallback(async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json')
      const data = await response.json()
      return data.ip || ''
    } catch (err) {
      return ''
    }
  }, [])

  const saveTokenToServer = useCallback(
    async (fcmToken: string, status = 'active') => {
      try {
        const callApiFn = isLogin ? callApiWithAuth : callApi
        const pathWebPush = isLogin
          ? PATHS.SSO.POST_FCM_TOKEN_AUTH
          : PATHS.SSO.POST_FCM_TOKEN

        window.clientIP = await requestClientIp()
        window.fcmToken = fcmToken

        await callApiFn(getSSOPath(pathWebPush), 'POST', {
          data: {
            fcm_token: fcmToken,
            ga_client_id: Cookies.get(GA_TOKEN_COOKIE),
            window_id: getWindowId(),
            cookie_id: getSubotCookieId(),
            client_ip: window.clientIP,
            client_agent: navigator?.userAgent || '',
            status: status,
            site_name: 'www.marrybaby.vn',
          },
        })
      } catch (err) {}
    },
    [isLogin, requestClientIp],
  )

  const retrieveToken = useCallback(() => {
    if (!messaging) {
      return
    }

    messaging
      .getToken({ vapidKey: vapidKey })
      .then((currentToken) => {
        // TODO: Send to server the token
        Log('[Firebase] Token ', currentToken)
        localStorage.setItem(FCM_TOKEN_KEY, currentToken)
        saveTokenToServer(currentToken)
      })
      .catch((err) => {
        Log('[Firebase] An error occurred while retrieving token.', err)
      })
  }, [saveTokenToServer])

  const requestPermission = useCallback(() => {
    if (typeof Notification?.requestPermission === 'undefined') {
      return
    }

    const handler = (permission: NotificationPermission) => {
      if (permission === 'granted') {
        retrieveToken()
        return
      }

      const prevFcmToken = localStorage.getItem(FCM_TOKEN_KEY)
      if (permission === 'denied' && prevFcmToken) {
        saveTokenToServer(prevFcmToken, 'inactive')
        localStorage.removeItem(FCM_TOKEN_KEY)
        Log('[Firebase] unsubscribe token:', prevFcmToken)
      }

      Log('[Firebase] Unable to get permission to notify.')
    }

    try {
      Notification.requestPermission().then(handler)
    } catch (error) {
      // Safari doesn't return a promise for requestPermissions and it
      // throws a TypeError. It takes a callback as the first argument
      // instead.
      if (error instanceof TypeError) {
        Notification.requestPermission(handler)
      }
    }
  }, [retrieveToken])

  useEffect(() => {
    setTimeout(() => {
      if (!document.getElementById('firebase-app-combat')) {
        const $script = document.createElement('script')
        $script.type = 'text/javascript'
        $script.src =
          'https://www.gstatic.com/firebasejs/9.14.0/firebase-app-compat.js'
        $script.id = 'firebase-app-combat'
        document.body.append($script)
      }
      setIsLoadScript(true)
    }, TIMEOUT_TO_LOAD)
  }, [])

  useEffect(() => {
    if (!isLoadScript) {
      return
    }

    /** Wait until the global `firebase` object is ready to access. Maximum time to wait is 5s */
    waitForUntilFinished({
      condition: () => typeof window.firebase !== 'undefined',
      finished: () => {
        if (!document.getElementById('firebase-messaging-combat')) {
          const $script = document.createElement('script')
          $script.type = 'text/javascript'
          $script.src =
            'https://www.gstatic.com/firebasejs/9.14.0/firebase-messaging-compat.js'
          $script.id = 'firebase-messaging-combat'
          document.body.append($script)
        }

        setIsFirebaseReady(true)
      },
      timeout: 5000,
    })
  }, [isLoadScript])

  useEffect(() => {
    if (!isFirebaseReady) {
      return
    }

    waitForUntilFinished({
      condition: () => Boolean(window.firebase && window.firebase.messaging),
      finished: () => {
        setIsFirebaseMsgReady(true)
      },
      timeout: 5000,
    })
  }, [isFirebaseReady])

  useEffect(() => {
    const firebase = window.firebase

    if (
      !isFirebaseReady ||
      !isFirebaseMsgReady ||
      !firebase ||
      !firebase.messaging
    ) {
      return
    }

    if (!firebase.messaging.isSupported()) {
      Log(
        '[Firebase] Do not support this browser. Access this to read the documentation: ' +
          'https://firebase.google.com/docs/web/environments-js-sdk',
      )
      return
    }

    firebase.initializeApp(firebaseConfig)
    messaging = firebase.messaging()
    messaging.onMessage((payload) => {
      Log('[Firebase] Foreground Message received:', payload)
      if (payload.data || payload.notification) {
        pushNotifications({
          type: 'firebase',
          title: payload.data?.title || payload.notification?.title || '',
          message: payload.data?.body || payload.notification?.body || '',
          displayIcon: payload.data?.icon || payload.notification?.icon || '',
          image: payload.data?.image || payload.notification?.image || '',
          meta: {
            actionUrl: payload.data?.action_url || '',
            campaignId: payload.data?.campaign_id || '',
            siteName: payload.data?.site_name || '',
          },
        })
      }
    })

    requestPermission()
  }, [isFirebaseReady, isFirebaseMsgReady])

  useEffect(() => {
    if (typeof navigator.serviceWorker === 'undefined') {
      return
    }

    // navigator.serviceWorker
    //   .getRegistration('/firebase-cloud-messaging-push-scope')
    //   .then(function (registration) {
    //     if (registration) {
    //       registration
    //         .unregister()
    //         .then(function () {
    //           console.log('[Firebase] Unregistered old service worker.')
    //         })
    //         .catch(function (error) {
    //           console.log(
    //             '[Firebase] Error unregistering old service worker:',
    //             error,
    //           )
    //         })
    //     } else {
    //       console.log(
    //         '[Firebase] No service worker registered for Firebase Cloud Messaging push scope.',
    //       )
    //     }
    //   })
    //   .catch(function (error) {
    //     console.error(
    //       '[Firebase] Error getting service worker registration:',
    //       error,
    //     )
    //   })

    // const firebaseConfigParams = new URLSearchParams(firebaseConfig).toString()
    // navigator.serviceWorker
    //   .register(`/firebase-messaging-sw.js?${firebaseConfigParams}`)
    //   .then(() => {
    //     //
    //   })
    //   .catch((err) => {
    //     console.log('Service worker registration failed, error:', err)
    //   })
  }, [])

  return null
}
